<app-head></app-head>

<div class="main-container">

  <div class="top-container">
    <h2 style="font-family: 'Lato', sans-serif; font-weight: 900"> Inventaire </h2>
    <button mat-raised-button (click)="openPopin()" style="color: #16191e">Ajouter un produit</button>
  </div>

  <div>
    <h5 style="font-family: 'Lato', sans-serif; font-weight: 600"> Liste des tous les produits</h5>
  </div>

  <div class="search-container">
    <form class="search">
      <button mat-icon-button>
        <mat-icon fontIcon="search"></mat-icon>
      </button>
      <input class="search-input" type="text" placeholder="Chercher un produit" #filter
             (keyup)="searchResults(filter.value)">
    </form>
  </div>
  <div *ngIf="errorMessage">
    <p style="color: red; font-size: 14px">{{ errorMessage }}</p>
  </div>
  <div class="item-dashboard">
    <table mat-table [dataSource]="filterData" class="table-container">
      <!--Category Column -->
      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef> Catégorie</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="!element.isEditMode; else editName">
            {{ element.category }}
          </ng-container>
          <ng-template #editName>
            <input class="edit-line" [(ngModel)]="element.category" placeholder="Catégorie">
          </ng-template>
        </td>
      </ng-container>

      <!-- Product Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Nom du Produit</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="!element.isEditMode; else editName">
            {{ element.name }}
          </ng-container>
          <ng-template #editName>
            <input class="edit-line" [(ngModel)]="element.name" placeholder="Nom du Produit">
          </ng-template>
        </td>
      </ng-container>

      <!-- Minimum quantity Column -->
      <ng-container matColumnDef="minimum_quantity">
        <th mat-header-cell *matHeaderCellDef> Quantité minimum</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="!element.isEditMode; else editQuantity">
            {{ element.minimum_quantity }}
          </ng-container>
          <ng-template #editQuantity>
            <input class="edit-line" [(ngModel)]="element.minimum_quantity" placeholder="Quantité minimum">
          </ng-template>
        </td>
      </ng-container>

      <!-- Purchase Price Column -->
      <ng-container matColumnDef="purchase_price">
        <th mat-header-cell *matHeaderCellDef> Prix d'achat</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="!element.isEditMode; else editPurchasePrice">
            {{ format_price(element.purchase_price) }}
          </ng-container>
          <ng-template #editPurchasePrice>
            <input class="edit-line" [(ngModel)]="element.purchase_price" placeholder="Prix d'achat">
          </ng-template>
        </td>
      </ng-container>

      <!-- Sales Price Column -->
      <ng-container matColumnDef="sales_price">
        <th mat-header-cell *matHeaderCellDef> Prix carton</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="!element.isEditMode; else editSalesPrice">
            {{ format_price(element.sales_price) }}
          </ng-container>
          <ng-template #editSalesPrice>
            <input class="edit-line" [(ngModel)]="element.sales_price" placeholder="Prix carton">
          </ng-template>
        </td>
      </ng-container>

      <!-- Pack Price Column -->
      <ng-container matColumnDef="pack_price">
        <th mat-header-cell *matHeaderCellDef> Prix paquet</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="!element.isEditMode; else editPackPrice">
            {{ format_price(element.pack_price) }}
          </ng-container>
          <ng-template #editPackPrice>
            <input class="edit-line" [(ngModel)]="element.pack_price" placeholder="Prix paquet">
          </ng-template>
        </td>
      </ng-container>

      <!-- Piece Price Column -->
      <ng-container matColumnDef="piece_price">
        <th mat-header-cell *matHeaderCellDef> Prix piece</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="!element.isEditMode; else editPiecePrice">
            {{ format_price(element.piece_price) }}
          </ng-container>
          <ng-template #editPiecePrice>
            <input class="edit-line" [(ngModel)]="element.piece_price" placeholder="Prix pièce">
          </ng-template>
        </td>
      </ng-container>

      <!-- Edit button Column -->
      <ng-container matColumnDef="item_id_modify">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-icon *ngIf="!element.isEditMode" (click)="toggleEditMode(element)">create</mat-icon>
          <button mat-stroked-button
                  style="color: #16191e; width: 90px"
                  *ngIf="element.isEditMode"
                  (click)="updateItem(element)"
          >Confirmer
          </button>
        </td>
      </ng-container>

      <!-- Delete button Column -->
      <ng-container matColumnDef="item_id_delete">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-icon (click)="deleteItem(element.id)">delete</mat-icon>
        </td>
      </ng-container>

      <!-- Duplicate button Column  -->
      <ng-container matColumnDef="item_id_duplicate">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-icon (click)="duplicateItem(element.id)">filter_none</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>

<app-popin *ngIf="isPopinOpen" (close)="closePopin()">
  <div class="create-container">
    <h2 style="font-weight: 600; text-align: center">Ajouter un produit</h2>

    <div class="line-container">
      <div class="box-container" style="flex: 3">
        <span *ngIf="itemForm.name" class="box-label">Nom du produit</span>
        <input type="text" class="text-input" id="name" [(ngModel)]="itemForm.name" placeholder="Nom du Produit"
               required>
      </div>

      <div class="box-container" style="flex: 2">
        <span *ngIf="itemForm.category" class="box-label">Catégorie</span>
        <input type="text" class="text-input" id="categorie" [(ngModel)]="itemForm.category"
               placeholder="Catégorie">
      </div>
    </div>

    <div class="line-container">
      <div class="box-container">
        <span *ngIf="itemForm.minimum_quantity" class="box-label">Quantité minimum</span>
        <input type="number" class="text-input" id="min_quant" [(ngModel)]="itemForm.minimum_quantity"
               placeholder="Quantité minimum" required>
      </div>
      <div class="box-container">
        <span *ngIf="itemForm.maximum_quantity" class="box-label">Quantité maximum</span>
        <input type="number" class="text-input" id="max_quant" [(ngModel)]="itemForm.maximum_quantity"
               placeholder="Quantité maximum" required>
      </div>
    </div>

    <div class="line-container">
      <div class="box-container">
        <span *ngIf="itemForm.purchase_price" class="box-label">Prix d'achat</span>
        <input type="number" class="text-input" id="purchase_price" [(ngModel)]="itemForm.purchase_price"
               placeholder="Prix d'achat" required>
      </div>
      <div class="box-container">
        <span *ngIf="itemForm.sales_price" class="box-label">Prix carton</span>
        <input type="number" class="text-input" id="location" [(ngModel)]="itemForm.sales_price"
               placeholder="Prix carton" required>
      </div>
    </div>

    <div class="line-container">
      <div class="box-container">
        <span *ngIf="itemForm.pack_price" class="box-label">Prix paquet</span>
        <input type="number" class="text-input" id="pack_price" [(ngModel)]="itemForm.pack_price"
               placeholder="Prix paquet" required>
      </div>
      <div class="box-container">
        <span *ngIf="itemForm.piece_price" class="box-label">Prix piece</span>
        <input type="number" class="text-input" id="piece_price" [(ngModel)]="itemForm.piece_price"
               placeholder="Prix piece" required>
      </div>
    </div>

    <button mat-raised-button (click)="createItems()">Ajouter</button>
    <div *ngIf="errorMessage">
      <p style="color: red; font-size: 14px">{{ errorMessage }}</p>
    </div>
  </div>
</app-popin>


<app-popin *ngIf="isdeletePopin" (close)="isdeletePopin=false">
  <div class="create-container">
    <h3 style="font-weight: 600; text-align: center">Confirmer la suppression</h3>
    <button mat-raised-button (click)="confirmDelete()">Confirmer</button>
    <button mat-raised-button (click)="isdeletePopin=false">Annuler</button>
  </div>
</app-popin>


